import {
  bool,
  func,
  node,
  number,
  object,
  oneOfType,
  shape,
  string,
} from 'prop-types'

import FormControlWithFloatingLabel from 'views/components/molecules/FormControlWithFloatingLabel'

const InputTextWithFloatingLabel = props => {
  const id = props.id ? props.id : props.name

  return <FormControlWithFloatingLabel {...props} id={id} formControl="input" />
}

InputTextWithFloatingLabel.propTypes = {
  autoFocus: bool,
  children: node,
  label: string,
  value: string,
  watch: string,
  defaultValue: string,
  name: string.isRequired,
  id: string,
  disabled: bool,
  inputType: string,
  highlight: bool,
  errorMessage: string,
  disableAutoCompleteAndFriends: bool,
  onBlur: func,
  onKeyUp: func,
  onClear: func,
  onChange: func,
  onMouseEnter: func,
  onMouseLeave: func,
  onFocus: func,
  required: bool,
  placeholder: string,
  register: func,
  errors: shape({}),
  useExternalValidator: bool,
  adyenField: string,
  minLength: oneOfType([string, number]),
  maxLength: oneOfType([string, number]),
  isDeclarative: bool,
  isNotEqualTo: shape({
    fieldId: string.isRequired,
    errorMessage: string.isRequired,
  }),
  customValidityMessage: oneOfType([object, string]),
  customPatternMismatchMessage: oneOfType([object, string]),
  tooltipText: string,
  rounded: bool,
  roundedRight: bool,
  roundedLeft: bool,
}

InputTextWithFloatingLabel.defaultProps = {
  adyenField: null,
  children: null,
  customPatternMismatchMessage: null,
  customValidityMessage: null,
  disableAutoCompleteAndFriends: false,
  disabled: null,
  errorMessage: null,
  errors: null,
  highlight: null,
  id: null,
  inputType: 'text',
  isDeclarative: false,
  isNotEqualTo: undefined,
  label: '',
  maxLength: undefined,
  minLength: undefined,
  onBlur: null,
  onChange: null,
  onClear: null,
  onKeyUp: null,
  placeholder: null,
  register: null,
  required: null,
  useExternalValidator: false,
  watch: null,
  tooltipText: null,
}

export default InputTextWithFloatingLabel
